import { ReactNode } from 'react';

export enum ROUTES {
  DASHBOARD = '/',
  CANCELLED_ORDERS = '/dashboard/cancelled-orders',
  SIGN_IN = '/sign-in',
  ABOUT_US = '/about-us',
  PROFILE = '/profile',
  USERS_LIST = '/users-list/:type/:id?',
  USERS_LIST_INDEX = '/users-list',
  PARTNER_DETAILS = '/partner-details/:id',
  PARTNER_DETAILS_INDEX = '/partner-details',
  PARTNERS_LIST = '/partners-list',
  CATEGORIES = '/categories',
  CATEGORY_DETAILS = '/categories/:id',
  REGIONS_AND_PICKUP = '/regions-and-pickup/:tab/:id?',
  REGIONS_AND_PICKUP_INDEX = '/regions-and-pickup',
  REGION = '/region',
  REGION_SETTLEMENTS = '/region/:id',
  PICKUP = '/pickup',
  PICKUP_SETTLEMENTS = '/pickup/:id',
  CATEGORY_FILTERS = '/categories/filters',
  CATEGORY_FILTER_DETAILS = '/categories/filters/:filterId',
  BANNERS = '/banners',
  PRODUCTS = '/products',
  STOCK_BALANCES = '/stock-balances',
  PRODUCT_CREATE = '/products/create',
  FEEDBACKS = '/feedbacks',
  PRODUCT_DETAILS = '/products/:id',
  IMPORT = '/import',
  IMPORT_STOCKS = '/stocks-import',
  IMPORTS_LIST = '/import/list',
  GENERATE_QR = '/generate-qr',
  BANNER_DETAILS = '/banners/:id',
  ORDERS = '/orders',
  SUBSCRIPTIONS = '/subscriptions',
  ORDER_DETAILS = '/orders/:id',
  SEO = '/seo',
  FEEDS = '/feeds',
  COMMISSION = '/commission',
  SETTINGS = '/settings',
  ACCOUNTING_CASH_REGISTERS = '/accounting/cash-registers/:id?',
  ACCOUNTING_CASH_REGISTERS_INDEX = '/accounting/cash-registers',
  CONTENT_PAGES = '/content/pages',
  CONTENT_PAGE_DETAILS = '/content/pages/:id',
  CONTENT_PAGE_EXAMPLE = '/content/pages/create',
  NOT_FOUND = '*',
}

export interface IRouteConfig {
  title: string;
  path: ROUTES;
  component: ReactNode;
  icon?: Element;
}
